import React from "react";

const LoadingCampaigns = () => {

    return (

        <div className="loading-state">

            <h3>Loading Campaigns...</h3>

        </div>

    );

};

export default LoadingCampaigns;